import { setCookie, deleteCookie } from 'utilities/browser';
import { isConsentGranted, cookieCategory } from 'features/cookieConsent';

import config from './config';

function setGeoLocationCookie (locationCoords) {

	if (isConsentGranted(cookieCategory.Functional)) {
		setCookie(
			config.cookieName,
			JSON.stringify(locationCoords),
			0,
			window.lp.globals.cookieDomain,
			undefined,
			true,
			true
		);
	} else {
		deleteCookie(config.cookieName, window.lp.globals.cookieDomain);
	}

}

export default setGeoLocationCookie;
